import { Component } from '@angular/core';

@Component({
    selector: 'agmo-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss']
})
export class LoadingComponent { }